import React from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import newmessage from '../../../../images/new-message.svg'
import { FaEnvelope, FaArrowLeft} from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'

const EmployerMessages = () => {
  return (
    <div>
       <EmployerNavbar/>
       <Container fluid className='p-0'>
          <div className='message-head py-3 mt-4 d-flex justify-content-between align-items-center'>
            <h1 className='ps-4'>Messages</h1>
            <Link to='/employernewmessages' className='pe-4'>
             <img src={newmessage} alt='new'/>
          </Link>
          </div>
          <div className='align-items-center text-center justify-content-center py-5 my-5'>
            <h1 className='inner-section-info mt-5 pt-5'>You have no Messages yet</h1>
           <FaEnvelope className='inner-section-envelope mb-5'/>
          </div>
      </Container>
    </div>
  )
}

export default EmployerMessages
